import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { Slider } from 'basic-components';
import { TextSize } from 'basic-components/icons';

import { When } from 'react-if';

import classNames from 'classnames';
import './PdfZoomer.scss';

const PdfZoomer = ({ scale, setScale }) => {
  const [isSliderOpen, setIsSliderOpen] = useState(false),
        sliderFormatter = useCallback(val => `${val * 100}%`, [])

  return (
    <div className={
      classNames(
        "pdf__viewer__zoomer",
        { "pdf__viewer__zoomer--is-open": isSliderOpen }
      )
    }>
      <div className="pdf__viewer__zoomer__slider">
        <Slider
            defaultValue={scale}
            max={3}
            min={0.25}
            onAfterChange={setScale}
            step={0.25}
            tipFormatter={sliderFormatter}
            withTooltip
        />
      </div>
      <div
          onClick={() => setIsSliderOpen(s => !s)}
          style={{ cursor: "pointer", height: 16, width: 16 }}
      >
        <TextSize
            height={16}
            width={16}
        />
      </div>
      <When condition={isSliderOpen}>
        {() => (
          <div 
              className="pdf__viewer__zoomer__cancel-bg"
              onClick={() => setIsSliderOpen(false)}
          />
        )}
      </When>
    </div>
  )
}

PdfZoomer.propTypes = {
  scale: PropTypes.number.isRequired,
  setScale: PropTypes.func.isRequired
}

export default PdfZoomer